import { useTranslation } from 'react-i18next'
import { ICP_ICP_ID } from '../../constants/tokenIds'
import useBalances from '../../hooks/useBalances'
import { UseStakeButtonProps } from '../../interfaces/staking'
import { useCurrentWallet, useUserTokens } from '../../state'
import { formatNumber } from '../../utils/formatNumber'
import { e8sToDecimals } from '../../utils/validationHelper'

export const useStakeButton = ({
  icpToken,
  nicpToken,
  waterNeuron,
  wnInfo,
  amount,
  commission,
  review,
}: UseStakeButtonProps) => {
  const { t } = useTranslation()
  const { findBalance } = useBalances()
  const { addToken } = useUserTokens()
  const { currentWallet } = useCurrentWallet()

  const { fee, decimals } = icpToken

  const balance = findBalance({ id: ICP_ICP_ID })?.balance || 0
  const minDeposit = Number(wnInfo.minimum_deposit_amount)

  let userError
  if (!amount) {
    userError = t('stake.noAmount')
  } else if (amount + commission + fee * 2n > balance) {
    userError = t('stake.notEnough', { tokenSymbol: 'ICP' })
  } else if (amount < minDeposit) {
    userError = t('stake.depositTooSmall', {
      minDeposit: formatNumber(minDeposit * 10 ** -decimals),
    })
  }

  const reviewStake = () => {
    const { exchange_rate, total_icp_deposited } = wnInfo

    const toAmount = e8sToDecimals(amount * exchange_rate, decimals * 2)
    const reward = e8sToDecimals(waterNeuron.computeRewards(total_icp_deposited, amount), decimals)

    review({
      toAmount: formatNumber(toAmount)!,
      attrs: {
        [t('stake.futureReward')]: formatNumber(reward, 'WTN')!,
      },
      action: async () => {
        await waterNeuron.stake(amount, icpToken)

        addToken(currentWallet, nicpToken.id)
      },
    })
  }

  return { userError, reviewStake }
}
